(function () {
  'use strict';

  let originalTitle = null;
  let scheduled = false;

  function parseVariants(productData) {
    if (Array.isArray(productData.variants)) return productData.variants;
    if (typeof productData.variants !== 'string') return [];

    try {
      const raw = productData.variants;
      const start = raw.indexOf('[');
      const end = raw.lastIndexOf(']') + 1;
      if (start === -1 || end === 0) return [];

      const json = raw.substring(start, end)
        .replace(/\n/g, ' ')
        .replace(/\s+/g, ' ')
        .replace(/"title":\s*"([^"]*)""/g, '"title": "$1\\\""')
        .replace(/"title":\s*"([^"]*?)"(?=\s*\/)/g, '"title": "$1\\\"');
      return JSON.parse(json);
    } catch (error) {
      console.error('[variant repair failed]', error);
      return [];
    }
  }

  function updateBoostCards() {
    scheduled = false;

    const productList = document.querySelector('.boost-sd__filter-product-list');
    if (!productList) return;

    const params = new URLSearchParams(window.location.search);
    const heightFilter = params.get('pf_opt_height');
    const qtyFilter = (params.get('pf_opt_quantity') || '').replace(/%2F/g, '/').trim();
    const candleType = (params.get('pf_pt_candle_type') || '').replace(/\+/g, ' ').trim();
    const filterKey = [heightFilter || '', qtyFilter, candleType].join('|');

    const collectionTitle = document.querySelector('.boost-sd__header-title');
    if (collectionTitle) {
      if (!originalTitle) originalTitle = collectionTitle.textContent.trim();
      const title = candleType && heightFilter
        ? `${heightFilter} ${candleType}`
        : candleType || (heightFilter ? `${heightFilter} ${originalTitle}` : originalTitle);
      if (collectionTitle.textContent.trim() !== title) collectionTitle.textContent = title;
    }

    productList.querySelectorAll('[data-product]').forEach(function (card) {
      if (card.dataset.priceProcessed === filterKey) return;

      let productData;
      try {
        productData = JSON.parse(card.dataset.product.replace(/&quot;/g, '"'));
      } catch (error) {
        return;
      }

      const variants = parseVariants(productData);
      const matchedVariants = variants.filter(function (variant) {
        const title = variant.title || '';
        return (!heightFilter || title.includes(heightFilter)) &&
          (!qtyFilter || title.includes(qtyFilter));
      });
      if (!matchedVariants.length) return;

      const prices = matchedVariants
        .map(function (variant) { return Number(variant.price); })
        .filter(function (price) { return !Number.isNaN(price); });
      if (!prices.length) return;

      const minPrice = Math.min.apply(Math, prices);
      const maxPrice = Math.max.apply(Math, prices);
      const price = card.querySelector('.boost-sd__format-currency');
      if (price) {
        price.textContent = minPrice === maxPrice
          ? `$${minPrice.toFixed(2)}`
          : `$${minPrice.toFixed(2)} – $${maxPrice.toFixed(2)}`;
      }

      const variantId = matchedVariants[0].id;
      if (variantId) {
        card.querySelectorAll("a[href*='/products/']:not(.height-chip)").forEach(function (link) {
          try {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('variant', variantId);
            link.href = url.toString();
          } catch (error) {
            // Leave the original link intact if an app renders an invalid URL.
          }
        });
      }

      card.dataset.priceProcessed = filterKey;
    });
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateBoostCards);
  }

  function init() {
    const root = document.body;
    if (!root) return;

    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(root, { childList: true, subtree: true });
    window.addEventListener('popstate', scheduleUpdate);
    scheduleUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
